export enum HrStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
